/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["header[_ngcontent-%COMP%]{display:flex;padding:10px 20px;border-top:5px solid #38a2ff;background:#f9f9f9;align-items:center;justify-content:space-between;position:fixed;z-index:5;width:100%;top:0;left:0;height:70px;box-sizing:border-box;box-shadow:0 0 10px 1px rgba(0,0,0,.3)}.app-title[_ngcontent-%COMP%]{cursor:pointer;outline:0}.pageBody[_ngcontent-%COMP%]{margin-top:70px;min-height:calc(100vh - 70px)}.active[_ngcontent-%COMP%]{font-weight:700;text-decoration:underline}"];
export { styles as styles };
